<template lang="pug">
  .container
    h1.main_title Dashboard
    .row
      .col-md-12(v-if="pieLoading || stackLoading")
        .loader
      .col-md-12(v-else)
        .col-md-12
          h4
            i.glyphicon.glyphicon-globe
            span  Category
          highcharts(:options="pieOptions")
          .hide_logo
        .col-md-12
          h4
            i.glyphicon.glyphicon-object-align-bottom
            span  Device Status
          highcharts(:options="stackedOptions")
          .hide_logo
    //- h1.main_title World
    //- .row
    //-   .col-md-12(v-if="mapLoading")
    //-     .loader
    //-   .col-md-12(v-else)
    //-     highmaps(:options="mapOptions")
    //-     .hide_logo.hide_logo_map
</template>

<script>
import _ from 'lodash'
import Highcharts from 'highcharts'
/* unable changing the path to static/map/world.geo.json */
import World from 'static/map/world.geo.json'
import { getDeviceRef, getDeviceOnlineRef, getUserRef } from 'src/index'

export default {
  data () {
    return {
    /* default */
      ipLocationData: [],
    /* data status */
      fbDeviceLoaded: false,
      ip2LocationLoaded: false,
      fbDeviceOnlineLoaded: false,
      fbUserLoaded: false,
    /* chart options */
      pieOptions: {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie'
        },
        title: {
          text: ''
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.percentage:.1f} %',
              style: {
                color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
              }
            }
          }
        },
        series: [{
          name: 'Brands',
          colorByPoint: true,
          data: [{
            name: 'Microsoft Internet Explorer',
            y: 56.33
          }, {
            name: 'Chrome',
            y: 24.03,
            sliced: true,
            selected: true
          }, {
            name: 'Firefox',
            y: 10.38
          }, {
            name: 'Safari',
            y: 4.77
          }, {
            name: 'Opera',
            y: 0.91
          }, {
            name: 'Proprietary or Undetectable',
            y: 0.2
          }]
        }]
      },
      mapOptions: {
        colors: ['rgba(19,64,117,0.05)', 'rgba(19,64,117,0.2)', 'rgba(19,64,117,0.4)', 'rgba(19,64,117,0.5)', 'rgba(19,64,117,0.6)', 'rgba(19,64,117,0.8)', 'rgba(19,64,117,1)'],
        title: {
          text: 'Device density by country'
        },

        mapNavigation: {
          enabled: true
        },

        legend: {
          title: {
            text: 'Amount of device',
            style: {
              color: (Highcharts.theme && Highcharts.theme.textColor) || 'black'
            }
          },
          align: 'left',
          verticalAlign: 'bottom',
          floating: true,
          layout: 'vertical',
          valueDecimals: 0,
          backgroundColor: (Highcharts.theme && Highcharts.theme.legendBackgroundColor) || 'rgba(255, 255, 255, 0.85)',
          symbolRadius: 0,
          symbolHeight: 14
        },

        colorAxis: {
          min: 0,
          stops: [
            [0, '#EFEFFF'],
            [0.5, Highcharts.getOptions().colors[0]],
            [1, Highcharts.Color(Highcharts.getOptions().colors[0]).brighten(-0.5).get()]
          ]
        },
        series: [{
          data: [
            {
              'code': 'AF',
              'name': 'Afghanistan',
              'value': 53
            },
            {
              'code': 'AL',
              'name': 'Albania',
              'value': 117
            },
            {
              'code': 'DZ',
              'name': 'Algeria',
              'value': 15
            },
            {
              'code': 'AS',
              'name': 'American Samoa',
              'value': 342
            }
          ],
          mapData: World,
          joinBy: ['iso-a2', 'code'],
          animation: true,
          name: 'Amount',
          states: {
            hover: {
              color: '#a4edba'
            }
          },
          shadow: false
        }]
      },
      stackedOptions: {
        chart: {
          type: 'column'
        },
        title: {
          text: ' '
        },
        xAxis: {
          categories: ['Apples', 'Oranges', 'Pears', 'Grapes', 'Bananas']
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Amount of device'
          },
          stackLabels: {
            enabled: true,
            style: {
              fontWeight: 'bold',
              color: (Highcharts.theme && Highcharts.theme.textColor) || 'gray'
            }
          }
        },
        legend: {
          align: 'right',
          x: 0,
          verticalAlign: 'top',
          y: 0,
          // floating: true,
          backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || 'white',
          borderColor: '#CCC',
          borderWidth: 1,
          shadow: false
        },
        tooltip: {
          headerFormat: '<b>{point.x}</b><br/>',
          pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: true,
              color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white'
            }
          }
        },
        series: [{
          name: 'John',
          data: [5, 3, 4, 7, 2]
        }, {
          name: 'Jane',
          data: [2, 2, 3, 2, 1]
        }, {
          name: 'Joe',
          data: [3, 4, 4, 2, 5]
        }]
      }
    }
  },
  firebase () {
    return {
      fbDevice: {
        source: getDeviceRef(),
        asObject: true,
        readyCallback: () => {
          this.fbDeviceLoaded = true
        }
      },
      fbDeviceOnline: {
        source: getDeviceOnlineRef(),
        asObject: true,
        readyCallback: () => {
          this.fbDeviceOnlineLoaded = true
        }
      },
      fbUser: {
        source: getUserRef(),
        readyCallback: () => {
          this.fbUserLoaded = true
        }
      }
    }
  },
  computed: {
    deviceCountOnTypeID () {
      /* count amount on column 'type_id' in fbDevice and output a obj */
      const obj = {}
      _.forEach(this.fbDevice, (client, key) => {
        _.forEach(client, (value, key) => {
          const typeName = this.getDeviceType(value)
          if (key === 'typeId') {
            let count = obj[typeName] || 0
            obj[typeName] = count + 1
          }
        })
      })
      // console.log(obj)
      return obj
    },
    deviceCountOnlineTypeID () {
      /* count amount on column 'type_id' in fbDevice and output a obj */
      const onlineDevices = _.keys({...this.fbDeviceOnline})
      const obj = {}
      _.forEach(this.fbDevice, (client, clientKey) => {
        const online = (_.indexOf(onlineDevices, clientKey) !== -1)
        _.forEach(client, (value, key) => {
          const typeName = this.getDeviceType(value)
          if (key === 'typeId' && online) {
            let count = obj[typeName] || 0
            obj[typeName] = count + 1
          }
        })
      })
      // console.log(obj)
      return obj
    },
  /* loading setting */
    /* control pie chart show when ready, and reproduce desired data for it. */
    pieLoading () {
      if (this.fbDeviceLoaded) {
        const obj = {...this.deviceCountOnTypeID}
        /* transform the obj to arr which highchart needed */
        const arr = _.transform(obj, (arr, value, key) => {
          arr.push({
            name: key,
            y: value
          })
        }, [])
        /* set default selected for pie chart */
        const data = _.orderBy(arr, 'y', 'desc')
        data[0] = {
          ...data[0],
          sliced: true,
          selected: true
        }
        this.pieOptions.series[0].data = data
        return false
      } else {
        return true
      }
    },
    /* control stack chart show when ready, and reproduce desired data for it. */
    stackLoading () {
      if (this.fbDeviceLoaded && this.fbDeviceOnlineLoaded) {
        const obj = {...this.deviceCountOnlineTypeID}
        const totalObj = {...this.deviceCountOnTypeID}
        const onlineObj = {/* can't use obj directly cause the order won't match to totalObj and the counting result will wrong! */}
        const offlineObj = {}
        /* need to add default 0 to each missing typeId */
        _.forEach(totalObj, (v, k) => {
          if (typeof obj[k] === 'undefined') {
            onlineObj[k] = 0
            offlineObj[k] = v
          } else {
            onlineObj[k] = obj[k]
            offlineObj[k] = v - obj[k]
          }
        })
        /* transform the obj to arr which highchart needed */
        const categories = _.keys(totalObj)
        const online = _.values(onlineObj)
        const offline = _.values(offlineObj)
        // console.log(
        //   totalObj,
        //   onlineObj,
        //   offlineObj
        // )
        // console.log(
        //   categories,
        //   online,
        //   offline
        // )
        /* set option for stack chart */
        this.stackedOptions.series = [
          {
            name: 'Online',
            data: online,
            color: '#4bcc1f'
          },
          {
            name: 'Offline',
            data: offline,
            color: '#c1c1c1'
          }
        ]
        this.stackedOptions.xAxis.categories = categories
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    getDeviceType (typeID) {
      const deviceType = ['power', 'matrix', 'mixer', 'splitter', 'mes', 'dio', 'smart controller', 'ir']
      return _.toUpper(deviceType[typeID - 1])
    }
  },
  ready () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.hide_logo {
  position: absolute;
  background-color: white;
  height: 13px;
  width: 94px;
  right: 0;
  bottom: 0;
}
.hide_logo_map {
  display: inline-block;
  position: absolute;
  background-color: white;
  height: 13px;
  width: 250px;
  right: 0;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// Dashboard.vue?063f48d7